import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { StepBiocatchEnum, } from 'src/app/shared/enums/biocatchContext.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { AdjustEvent } from 'src/app/shared/services/external/adjust/adjust.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { AccountCreationStatus } from '../detail-account-creation/detail-account-creation.component';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import { callbackAdjustCA } from 'src/app/shared/constants/adjust-callback';
import * as channelConstant from '../../../shared/constants/channel.constants';
import { DaliService } from '@dali/tagger-ng8';
import { PAGEVIEW as PAGEVIEW_FA, CHANNEL as CHANNEL_FA, COUNTRY as COUNTRY_FA, BUSINNESS as BUSINNESS_FA, ENVIRONMENT as ENVIRONMENT_FA, FAMILY as FAMILY_FA, SUBFAMILY as SUBFAMILY_FA, PRODUCT as PRODUCT_FA } from 'src/app/shared/constants/dali-fa-tc.constants';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
var PrincipalityCreditCardComponent = /** @class */ (function () {
    function PrincipalityCreditCardComponent(copyService, headerService, bioCatchService, navigationService, abreCuentasService, parametersService, channelCommunicatorService, bitacoraService, adjustEvent, loader, taggingServices, daliService, firmlyApprovedService) {
        this.copyService = copyService;
        this.headerService = headerService;
        this.bioCatchService = bioCatchService;
        this.navigationService = navigationService;
        this.abreCuentasService = abreCuentasService;
        this.parametersService = parametersService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.bitacoraService = bitacoraService;
        this.adjustEvent = adjustEvent;
        this.loader = loader;
        this.taggingServices = taggingServices;
        this.daliService = daliService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.showModal = false;
        this.isBtnDisabled = false;
        this.transactionkit = [];
        this.transaction = [];
        this.showSecondaryButton = true;
        this.terms = { text: '', title: '', terms_id: '' };
        this.buttonLabelsModal = {};
        this.copiesProperty = {};
        this.showBackBtn = true;
        this.showFotter = false;
        this.grayZone = false;
        this.headerService.show(true, false, true);
    }
    PrincipalityCreditCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.taggingServices.isFirmlyAprovedMono()) {
            this.sendPrincipalityPageLoad();
        }
        this.buttonLabelsModal = {
            primary: this.copyService.copies.principality_credit_card_modal_button,
        };
        this.checkboxTerms = {
            id: '1',
            label: this.copyService.copies.principality_credit_card_terms,
            checked: true,
            value: '1',
        };
        console.log(this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS), 'seteo');
        var postLogin = this.abreCuentasService.getPostlogin();
        var product = this.abreCuentasService.getproductSelected()
            .product_code;
        var isEvidente = this.bioCatchService.isEvidenteCase();
        this.bioCatchService.changeContext(StepBiocatchEnum.vinculacion, product, !postLogin, isEvidente);
        this.termsAndConditions =
            this.abreCuentasService.getPayDayProductSelected();
        this.acctStatus = AccountCreationStatus.NOT_REQUESTED;
        var product_type = this.abreCuentasService.getproductSelected().product_type;
        console.log('product_type', product_type);
        this.transaction = this.parametersService.getSetting(OpEnum.SAVING_TRANSACTION_KIT);
        if (!this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS)) {
            return;
        }
        this.documentInfo = this.abreCuentasService.getDocumentInfo();
        this.selectedProduct = this.abreCuentasService.getproductSelected();
        if (this.selectedProduct.product_type === BUSINESS_CONST.PRODUCT_TYPE_SAVINGS) {
            var event_1 = {
                eventToken: '3duuk6',
                callbackParams: callbackAdjustCA,
            };
            this.adjustEvent.adjustTrackEvent(event_1);
        }
        setTimeout(function () {
            _this.showFotter = true;
        }, 100);
        this.accountDetail();
        var creditCardTermsText = this.parametersService
            .getSetting(OpEnum.DATA_TERMS_CONDITIONS)
            .filter(function (accountTerm) { return accountTerm.id === 2; });
        this.terms = {
            text: creditCardTermsText[0].description,
            title: creditCardTermsText[0].code,
            terms_id: creditCardTermsText[0].id,
        };
        this.checkboxTerms = {
            id: this.terms.terms_id,
            label: this.copyService.copies.principality_credit_card_terms,
            checked: true,
            value: this.terms.terms_id,
        };
    };
    PrincipalityCreditCardComponent.prototype.accountDetail = function () {
        var _this = this;
        this.infoInferredIncomes = this.abreCuentasService.getinfoInferredIncomes();
        var costumerData = this.abreCuentasService.getCustomerData();
        this.client = this.abreCuentasService.getProspectResponse().client;
        if (this.infoInferredIncomes.account_type === '211' ||
            this.infoInferredIncomes.account_type === '218' ||
            this.infoInferredIncomes.account_type === '232') {
            this.copiesProperty = {
                termsLabel: 'principality_credit_card_link_label',
                mainLabel: 'principality_credit_card_title_saving_basic',
            };
        }
        // tslint:disable-next-line:no-collapsible-if
        if (this.channelCommunicatorService.getChannelId() !== '159') {
            if (this.client &&
                ((costumerData ? costumerData.basic.sub_segment_id : '') === '335' ||
                    (costumerData ? costumerData.basic.sub_segment_id : '') === '315')) {
                this.infoInferredIncomes.segment_id =
                    this.abreCuentasService.getCustomerData().basic.sub_segment_id;
            }
        }
        this.transactionkit = this.transaction.filter(function (transaction) {
            return transaction.account_type === _this.infoInferredIncomes.account_type &&
                transaction.segmentation_id === _this.infoInferredIncomes.segment_id;
        });
        this.transactionkit = this.transactionkit[0];
    };
    /**
     * Summary Show Modal
     */
    PrincipalityCreditCardComponent.prototype.toggleModal = function () {
        if (this.showSecondaryButton) {
            this.showModal = !this.showModal;
        }
        this.showSecondaryButton = true;
    };
    /**
     * Acción del modal
     *
     * *Modal action*
     *
     * @param event
     * @type {function}
     */
    PrincipalityCreditCardComponent.prototype.modalAction = function (event) {
        if (event.type === 'primary') {
            this.downloadPdf();
        }
    };
    /**
     * Method to download pdf
     */
    PrincipalityCreditCardComponent.prototype.downloadPdf = function () {
        // tslint:disable-next-line:no-unused-expression
        this.channelCommunicatorService.getChannelId() === '163'
            ? window.open(this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS)[0]
                .pdfUrl)
            : this.channelCommunicatorService
                .getImpl()
                .openPdf(this.parametersService.getSetting(OpEnum.DATA_TERMS_CONDITIONS)[0]
                .pdfUrl);
    };
    /**
     * Summary Event to change checkbox and set Prop
     * @param event
     */
    PrincipalityCreditCardComponent.prototype.checkboxChange = function (event) {
        this.checkboxTerms.checked = event.checked;
        this.abreCuentasService.setFiProperty('checkboxTerms', this.checkboxTerms);
        this.enableNextButton();
    };
    /**
     * Summary Enable the Button
     */
    PrincipalityCreditCardComponent.prototype.enableNextButton = function () {
        this.isBtnDisabled =
            !this.checkboxTerms.checked;
        console.log(this.checkboxTerms.checked);
    };
    /**
     * summary shipment request open account
     */
    PrincipalityCreditCardComponent.prototype.onNext = function () {
        this.bitacoraService.saveDataInBitacora('AHO_acepted');
        this.navigationService.navigateToGeneralInformation('139');
        return;
    };
    PrincipalityCreditCardComponent.prototype.onPrevious = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bitacoraService.saveDataInBitacora('Salida_voluntaria_oferta_AHO')];
                    case 1:
                        _a.sent();
                        this.navigationService.goToLoginPage();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Opens link to itau page
     *
     *
     * @memberof PrincipalityCreditCardComponent
     */
    PrincipalityCreditCardComponent.prototype.openLink = function () {
        if (this.channelCommunicatorService.getChannelId() ===
            channelConstant.CHANNEL.PORTALALLIES.CODE) {
            window.open(this.copyService.copies.principality_credit_card_link);
        }
        else {
            this.channelCommunicatorService
                .getImpl()
                .openExternalBrowser(this.copyService.copies.principality_credit_card_link, 5, true);
        }
    };
    /* ------------- Taggeo ------------- */
    /* ------------ Taggeo - PageLoad ------------ */
    PrincipalityCreditCardComponent.prototype.sendPrincipalityPageLoad = function () {
        var isApp = this.channelCommunicatorService.getChannelId() === '141';
        var productsType = {
            ORD: 'LD',
            TCR: 'TC',
        };
        var changes = [
            {
                path: PAGEVIEW_FA.pv14pageName.path,
                value: (isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking) + ":" + COUNTRY_FA.co + ":" + BUSINNESS_FA.pf + ":" + ENVIRONMENT_FA.loggeado + ":" + FAMILY_FA.services + ":" + SUBFAMILY_FA.request + ":" + PRODUCT_FA.request + ":" + PAGEVIEW_FA.pv14pageName.value,
            },
            {
                path: PAGEVIEW_FA.pv14pageFamily.path,
                value: PAGEVIEW_FA.pv14pageFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv14subFamily.path,
                value: PAGEVIEW_FA.pv14subFamily.value,
            },
            {
                path: PAGEVIEW_FA.pv14pageAction.path,
                value: PAGEVIEW_FA.pv14pageAction.value,
            },
            {
                path: PAGEVIEW_FA.pv14pageid.path,
                value: 'PrincipalityCreditCardComponent',
            },
            {
                path: PAGEVIEW_FA.pv14transactionName.path,
                value: "" + PAGEVIEW_FA.pv14transactionName.value.slice(0, -2) + this.taggingServices.getProductFlow(),
            },
            {
                path: PAGEVIEW_FA.pv14transactionTransactionStep.path,
                value: PAGEVIEW_FA.pv14transactionTransactionStep.value,
            },
        ];
        this.taggingServices.addCommonPageChanges(changes);
        this.daliService.pageLoad(changes);
    };
    return PrincipalityCreditCardComponent;
}());
export { PrincipalityCreditCardComponent };
